var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconShareUrl38 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 39 38"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3B3B3B",
  d: "M19.374 38c10.493 0 19-8.507 19-19s-8.507-19-19-19-19 8.507-19 19 8.507 19 19 19"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.178 19.107v-4.444h1.298v4.4c0 1.166.649 1.925 1.881 1.925 1.221 0 1.87-.759 1.87-1.925v-4.4h1.298v4.433c0 1.826-1.045 3.036-3.168 3.036-2.134 0-3.179-1.22-3.179-3.025M22.275 22l-1.628-2.739h-1.276v2.74h-1.287v-7.338h3.223c1.452 0 2.398.946 2.398 2.3 0 1.308-.858 2.012-1.738 2.155L23.76 22zm.11-5.038c0-.704-.528-1.166-1.254-1.166h-1.76v2.332h1.76c.726 0 1.254-.462 1.254-1.166M24.992 22v-7.337h1.287v6.204h3.233V22z"
}))));
export default SvgIconShareUrl38;